/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Should I aim for this exactly?`)
};

const es_iw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Debería aspirar a esta cifra exactamente?`)
};

const de_iw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollte ich das genau anstreben?`)
};

const nl_iw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moet ik hier precies naar streven?`)
};

const fr_iw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dois-je viser exactement ce chiffre ?`)
};

const it_iw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devo puntare esattamente a questo valore?`)
};

const pt_br2_iw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devo tentar atingir esse valor exato?`)
};

const pt_iw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devo procurar atingir exatamente este valor?`)
};

const ja_iw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この数値を厳密に目指すべきですか?`)
};

const zh_iw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我应该以这个数值为目标吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iw_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iw_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iw_faq_q4", locale)
	if (locale === "en") return en_iw_faq_q4(inputs)
	if (locale === "es") return es_iw_faq_q4(inputs)
	if (locale === "de") return de_iw_faq_q4(inputs)
	if (locale === "nl") return nl_iw_faq_q4(inputs)
	if (locale === "fr") return fr_iw_faq_q4(inputs)
	if (locale === "it") return it_iw_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_iw_faq_q4(inputs)
	if (locale === "pt") return pt_iw_faq_q4(inputs)
	if (locale === "ja") return ja_iw_faq_q4(inputs)
	return zh_iw_faq_q4(inputs)
};